import React, { useState } from 'react';
import insurerPic from './Images/HDFC_Life_Logo.svg.png';
import { CommaSeprator, isBeforeSep22_2025 } from './UtilityComponents/UtilityFunction';
import * as CopyToClipboard from 'react-copy-to-clipboard';

const InvestmentProposalQuote = ({ BuyData }) => {
    const [copyText, setCopyText] = useState(false);

    const handleCopy = () => {
        setCopyText(true)
        setTimeout(() => setCopyText(false), 2000);
        //alert("copied!")
    }

    
    return (
        <>
            <div className="ProposalQuotesMainPage">
                <div className="ProposalQuote" >
                    <img src={BuyData?.Image} />
                    <span className="s5">{BuyData?.PlanName}</span>
                </div>
                <div className="ProposalQuotes ProposalEnqBox d-flex justify-content-between">
                    <span className="s1">Enquiry#</span>
                    {/*<span className="s2">{BuyData.EnquiryNo}</span>*/}
                    <CopyToClipboard text={BuyData?.EnquiryNo}
                        onCopy={handleCopy} >
                        <span className="LeadID" ><span id="textCopeid" >{BuyData?.EnquiryNo} &nbsp;<i className="far fa-copy"></i></span></span>
                    </CopyToClipboard>
                    {copyText && <div className="Enq_popup">Copied!</div>}
                </div>
                <div className="p-3" >
                    <div className="InvestAmount ">
                        <span className="s3">Investment Amount</span>
                        <span className="s3">₹{CommaSeprator(BuyData?.ModelPremium)}</span>
                    </div>
                    {isBeforeSep22_2025() && <div className="InvestGst mt-2">
                        <span className="s3">+ GST</span>
                        <span className="s3">₹{CommaSeprator(BuyData?.ServiceTax)}</span>
                    </div>}
                </div>
                <div className="ProposalPremium">
                    <span className="s4">Total Premium
                       <p className="propFreq"> ({BuyData?.PaymentFreq === "Y" ? "Yearly" : 
                        BuyData?.PaymentFreq === "M" ? "Monthly" : 
                        BuyData?.PaymentFreq === "Q" ? "Quarterly" :
                                    BuyData?.PaymentFreq === "H" ? "Half Yearly" : ""})</p>
                    </span>
                    <span className="s6">₹{CommaSeprator(BuyData?.TotalPremium)}</span>
                </div>
            </div>
        </>
    );

}
export default InvestmentProposalQuote;


